import {
  Brain, MessagesSquare, Workflow, Database, Cloud, Code2, Sparkles,
} from "lucide-react";

const map = { Brain, MessagesSquare, Workflow, Database, Cloud, Code2, Sparkles };

export default function ServiceIcon({ name, className }) {
  const Icon = map[name] || Sparkles;
  return <Icon className={className} />;
}
